import { render, staticRenderFns } from "./data-table-create-calculation.vue?vue&type=template&id=ca175f00&scoped=true&"
import script from "./data-table-create-calculation.vue?vue&type=script&lang=js&"
export * from "./data-table-create-calculation.vue?vue&type=script&lang=js&"
import style0 from "./data-table-create-calculation.vue?vue&type=style&index=0&id=ca175f00&lang=scss&scoped=true&"
import style1 from "./data-table-create-calculation.vue?vue&type=style&index=1&id=ca175f00&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca175f00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca175f00')) {
      api.createRecord('ca175f00', component.options)
    } else {
      api.reload('ca175f00', component.options)
    }
    module.hot.accept("./data-table-create-calculation.vue?vue&type=template&id=ca175f00&scoped=true&", function () {
      api.rerender('ca175f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/data-table-create-calculation.vue"
export default component.exports